<template>
      <fiche-header :ressource="ressource"
                    @back="back"
                    @openAll="openAll"
                    @closeAll="closeAll">
      </fiche-header>
  <div class="fiche">
    <!-- Liste des sections de la fiche -->
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('SALARIE_LIST')">
        <slot name="section-salarie-list">
          <section-salarie-list ref="SALARIE_LIST"
                                id="SALARIE_LIST"
                                :extended="isExtended('SALARIE_LIST')"
                                :showButton="true"
                                :autoSave="true"
                                :readOnly="readOnly"
                                :moduleId="moduleId"
                                :searchText="searchText"
                                :ressourceHeader="ressource"
                                :fiche="fiche"
                                :salarie=selectedSalarie
                                :route="route"
                                :attribut="attribut"
                                @extended="setExtended"
                                @fullscreen="setFullscreen"
                                @status="updateStatus"
                                @toggleCardView="toggleCardView"
                                @updated="salarieUpdated"
                                @selectItem = "selectItem">
          </section-salarie-list>
        </slot>
    </v-col>
  </div>
</template>
<script lang="ts">
import { defineComponent, type PropType } from "vue";
import FicheBase from '@/framework/base/components/FicheBase';
import Route from '@/extend/classes/Route';
import { CiRouter } from '@/framework/base/helpers/NavHelper'
import { Fiches } from '@/generated/classes/AppSchema';
import { Extended } from '@/framework/base/classes/Schema';
import Salarie from '@/extend/classes/Salarie';
import FicheHeader from '@/framework/base/components/FicheHeader.vue';
import { GenFiche, RessourceGenFiche } from '@/generated/ressources/generatedRessources';
import SectionSalarieList from '@/extend/sections/SectionSalarieListExtend.vue';

export default defineComponent({
  extends: FicheBase,
  components: {
    SectionSalarieList,
    FicheHeader,
  },

  props: {
    salarie: {
      type: Object as PropType<Salarie>,
    },
  },

  created (): void {
    this.addFiches(this.sections);
  },

  data() {
    return {
      moduleId: 0,
      fiche: Fiches.SALARIE_LIST,
      sections: [
        'SALARIE_LIST',
      ],

    }
  },

  computed: {
    ressource () {
      return RessourceGenFiche(GenFiche.FICHE_SALARIE_LIST);
    },

    selectedSalarie (): Salarie {
      return this.salarie
    },
  },
  methods: {
    ficheMounted () {
      this.onShowSectionChanged();
      this.setFocus();
    },

    setFocus (): void {
      if (this.isMounted) {
        let res = false;
        let first = '';
        const route = CiRouter.getRoute();
        const notifSection = route ? route.section : '';
        this.sections.forEach(section => {
          // @ts-expect-error : generated method
          if (this.isDisplayed(section) && this.$refs[section] && this.$refs[section].allReadOnly && this.$refs[section].setFocus) {
            if (notifSection == section) {
              // @ts-expect-error : generated method
              this.$refs[section].setFocus(route);
              res = true;
            } else if (first == '') {
              first = section;
            }
          }
        })
        if (!res && first != '' && this.$refs[first]) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus(route);
        }
      }
    },

    // eslint-disable-next-line
    salarieUpdated (salarie: Salarie) {
    // To implement
    },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isDisplayed (value: string): boolean {
      if ((!this.salarie || this.salarie.id < 0) && value == 'SALARIE_LIST') {
        this.setExtended(new Extended('SALARIE_LIST', this.fiche, true));
      }
      return true;
    }
  }
})
</script>
